import { useEffect, useState } from 'react';

import { useDataModel } from '@/hooks/useDataModel';
import { logger } from '@/services/logger';
import { PersistedItem } from '@/types/DataModel';

/**
 * @returns the item hierarchies based on its category.
 */
const useItemHierarchies = (item: PersistedItem) => {

    const { dataModel } = useDataModel();
    const [itemHierarchies, setItemHierarchies] = useState<string[]>([]);

    useEffect(() => {

        // Prepare item hierarchies
        if (!item) {
            // We are creating a new item, we don't show any hierarchies
            return;
        }

        if (!item.category__) {
            logger.error('ItemEditorDialog: Item has no category assigned although it was persisted.', item);
            return;
        }

        const category = dataModel?.category(item.category__);
        if (!category) {
            logger.error(`ItemEditorDialog: Could not find category ${item.category__}`);
            return;
        }

        setItemHierarchies(category.hierarchies || []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        itemHierarchies,
    };

};

export { useItemHierarchies };
